import React from 'react';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';
import { Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import Separation from './Separation';
import Initial from './Initial';
import Financing from './Financing';
import Dues from './Dues';
import classNames from 'classnames';
import Background from 'components/common/Background';
import bg2 from 'assets/img/icons/spot-illustrations/corner-2.png';
import ecomBg from 'assets/img/illustrations/ecommerce-bg.png';
import { currency } from 'helpers/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import createMarkup from 'helpers/createMarkup';
import { Link } from 'react-router-dom';
import { useOrderHook } from '../useOrderHook';
import Additional from './Additional';
import Person from 'components/modules/person/Person';
import Input from 'components/common/Input';
import IconButton from 'components/common/IconButton';
import AdvanceTableWrapper from 'components/common/tables/AdvanceTableWrapper';
import AdvanceTable from 'components/common/tables/AdvanceTable';
import AdvanceTablePagination from 'components/common/tables/AdvanceTablePagination';
import BulAction from './BulAction';

const Notification = ({ notification: { title, linkFor, type }, isLast }) => {
 return (
  <li
   className={classNames('alert mb-0 rounded-0 py-3 px-card', {
    'alert-warning': type === 'warning',
    'greetings-item border-top': !(type === 'warning'),
    'border-0': isLast,
    'border-x-0 border-top-0': !isLast
   })}
  >
   <Row className="flex-between-center">
    <Col>
     <Flex>
      <FontAwesomeIcon
       icon="circle"
       className={classNames('mt-1 fs--2', {
        'text-primary': !type
       })}
      />
      <p className="fs--1 ps-2 mb-0" dangerouslySetInnerHTML={createMarkup(title)}></p>
     </Flex>
    </Col>
    <Col xs="auto" className="d-flex align-items-center">
     <Link to="#!" className="alert-link fs--1 fw-medium">
      {`View ${linkFor}`}
      <FontAwesomeIcon icon="chevron-right" className="ms-1 fs--2" />
     </Link>
    </Col>
   </Row>
  </li>
 );
};

const NewOrder = () => {
 const {
  /* auth, */
  watch,
  register,
  handleSubmit,
  errors,
  setValue,
  onError,
  verifyFields,
  onSubmitData,
  /* isLoading, */
  isError,
  error,
  discounts,
  columns,
  products,
  updateMyData,
  skipPageReset,
  editableRowIndex,
  setEditableRowIndex
 } = useOrderHook(); //  http://localhost:3000/64fcabcff42cf9c78dd6f271/app/orders/create

 const getRowProps = /* row */ () => ({ className: 'hover-actions-trigger align-middle' });

 /* if (isLoading)
  return (
   <div className="container vh-25">
    <Spinner className="position-absolute top-50 start-50 translate-middle" animation="grow" />
   </div>
  );
 else  */ if (isError)
  return (
   <div className="container vh-25">
    <p className="position-absolute top-50 start-50 translate-middle">{error}</p>
   </div>
  );

 return (
  <Form noValidate onSubmit={handleSubmit(onSubmitData, onError)}>
   <Card className="mb-3">
    <Card.Header className="position-relative">
     <Background
      image={ecomBg}
      className="d-none d-md-block bg-card z-index-1"
      style={{
       backgroundSize: '230px',
       backgroundPosition: 'right bottom',
       zIndex: '-1'
      }}
     />
     <div className="position-relative z-index-2">
      <div>
       <h3 className="text-primary mb-1">Orden de separación</h3>
       <p>Aqui es donde lo importante se hace eficaz </p>
      </div>
      <Flex className="py-3">
       <div className="pe-3">
        <p className="text-600 fs--1 fw-medium">Descuento</p>
        <h4 className="text-800 mb-0 d-flex">
         <span>{currency(watch('saving'), true)}</span>
         {watch('saving') > 0 && (
          <span className="ms-2 fs--1 text-700">
           {currency((watch('saving') * 1) / watch('defaultValues.totals'), true, true)}
          </span>
         )}
        </h4>
       </div>
       <div className="ps-3">
        <p className="text-600 fs--1">Total orden</p>
        <h4 className="text-800 mb-0 d-flex">
         <span>{currency(watch('defaultValues.totals') - watch('saving'), true)}</span>
         {watch('saving') > 0 && <del className="ms-2 fs--1 text-700">{currency(watch('defaultValues.totals'), true)}</del>}
        </h4>
       </div>
      </Flex>
     </div>
    </Card.Header>
    <Card.Body className="py-3">
     <ul className="mb-0 list-unstyled">
      <li className="alert mb-0 rounded-0 py-1 px-2 border-1 greetings-item alert-info">
       <Flex className="hover-actions-trigger px-2" justifyContent="sm-around" alignItems="center" wrap="wrap">
        <div className="d-flex align-items-center flex-wrap fs--2">
         <span className="fa-stack me-2 ms-n1 circle-dashed" style={{ width: '40px', height: '40px' }}>
          <FontAwesomeIcon icon="circle" className="fa-stack-2x fs--1 text-300" />
          <FontAwesomeIcon icon="building" className="fa-inverse fa-stack-1x fs-1 text-primary" ransform="shrink-3" />
         </span>
         <div>
          <small className="mb-0"> Agencia </small>
          <h6 className="mb-0 text-primary text-capitalize text-truncate" style={{ maxWidth: '200px' }}>
           <span className="p-0">{watch('emitters.0')?.name?.toLowerCase()}</span>
          </h6>
          <p className="mb-0">
           nit: {watch('emitters.0')?.nit} - cel: {watch('emitters.0')?.phone}
          </p>
         </div>
        </div>

        <div className="d-flex align-items-center flex-wrap fs--2">
         <span className="fa-stack me-2 ms-n1 circle-dashed" style={{ width: '40px', height: '40px' }}>
          <FontAwesomeIcon icon="circle" className="fa-stack-2x fs--1 text-300" />
          <FontAwesomeIcon icon="user-tie" className="fa-inverse fa-stack-1x fs-1 text-primary" ransform="shrink-3" />
         </span>
         <div className="flex-fill">
          <small className="mb-0"> Asesor </small>
          <h6 className="mb-0 text-primary text-capitalize text-truncate" style={{ maxWidth: '200px' }}>
           <span className="p-0">
            {watch('executor')?.firstName?.toLowerCase() + ' ' + watch('executor')?.lastName?.toLowerCase()}
           </span>
          </h6>
          <p className="mb-0">
           cc: {watch('executor')?.docNumber} - cel: {watch('executor')?.phone}
          </p>
         </div>
        </div>

        <div className="hover-actions start-0 top-50 translate-middle-y">
         <h5 className="mb-0 text-primary text-capitalize text-truncate" style={{ maxWidth: '200px' }}>
          5.3%
         </h5>
        </div>

        <div className="hover-actions end-0 top-50 translate-middle-y">
         <h5 className="mb-0 text-primary text-capitalize text-truncate" style={{ maxWidth: '200px' }}>
          3%
         </h5>
        </div>
       </Flex>
      </li>

      <li className="alert mb-0 rounded-0 py-2 px-card alert-warning border-x-0 border-top-0 mt-1">
       <Person
        title="Clientes"
        sub="Enpresa o persona que compra"
        Entities={e => {
         setValue('receivers', e);
         setValue(
          'customers',
          e.map(e => e._id)
         );
        }}
        //fixedEntity={auth?.person}
        err={!!errors?.receivers}
        type="customer"
        vr="warning"
        business={watch('defaultValues')?.company?._id}
       />
       <Input
        type="hidden"
        formControlProps={{ ...register('receivers', { required: true, validate: value => value?.length || false }) }}
       />
      </li>
     </ul>
    </Card.Body>
   </Card>

   <Card className="mb-3">
    <Background image={bg2} className="bg-card" />
    <Card.Body className="p-3 z-index-1">
     {/* {isLoading && !products.length ? (
      <div className="container vh-25">
       <Spinner className="position-absolute top-50 start-50 translate-middle" animation="grow" />
      </div>
     ) : ( */}
     <AdvanceTableWrapper
      columns={columns}
      data={products}
      sortable
      pagination
      perPage={5}
      selection={false}
      selectionColumnWidth={30}
      getRowProps={getRowProps}
      updateMyData={updateMyData}
      skipPageReset={skipPageReset}
      editableRowIndex={editableRowIndex}
      setEditableRowIndex={setEditableRowIndex}
     >
      <BulAction table />
      <AdvanceTable
       table
       headerClassName="bg-200 text-900 text-nowrap align-middle"
       rowClassName="align-middle white-space-nowrap"
       tableProps={{
        striped: true,
        className: 'fs--1 mb-0 overflow-hidden',
        responsive: true,
        hover: true,
        size: 'sm'
       }}
      />
      <div className="mt-3">
       <AdvanceTablePagination table />
      </div>
     </AdvanceTableWrapper>
     {/*  )} */}
    </Card.Body>
   </Card>

   {/* <Card className="mb-3">
    <Background image={bg2} className="bg-card" />
    <Card.Body className="p-3">
     <Flex alignItems="center" wrap="wrap">
      <h6 className="fs-6 m-0 text-secondary">P</h6>
      <div className="flex-1">
       <h4 className="m-0 text-secondary">roductos</h4>
       <p className="fs--2 m-0">Conoce al detalle cada producto de la orden</p>
      </div>
     </Flex>
     <Terrains data={watch('defaultValues')?.terrains || []} />
    </Card.Body>
   </Card> */}

   {watch('defaultValues') ? (
    <>
     <Additional setValue={setValue} watch={watch} discounts={discounts} />

     <Row className="g-3 mb-3">
      <Col sm={12} md={4}>
       <Separation watch={watch} register={register} errors={errors} setValue={setValue} verifyFields={verifyFields} />
      </Col>
      <Col sm={12} md={4}>
       <Initial watch={watch} register={register} errors={errors} setValue={setValue} verifyFields={verifyFields} />
      </Col>
      <Col sm={12} md={4}>
       <Financing watch={watch} register={register} errors={errors} setValue={setValue} verifyFields={verifyFields} />
      </Col>
     </Row>

     <Card className="mb-3">
      <Background image={bg2} className="bg-card" />
      <Card.Body className="p-3">
       <Flex alignItems="center" wrap="wrap">
        <h6 className="fs-6 m-0 text-primary">I</h6>
        <div className="flex-1">
         <h4 className="m-0 text-primary">niciales</h4>
         <p className="fs--2 m-0">El monto minimo en cada cuota es {currency(watch('defaultValues.minFeeIni'))}</p>
        </div>
       </Flex>
       <Row className="g-2">
        {watch('initials') > 0 ? (
         Array.from(Array(watch('initials') * 1).keys()).map(e => (
          <Col
           sm={6}
           md={4}
           key={e}
           className={classNames('border-end border-end-400 mb-1 py-1', {
            'bg-soft-success': !(e % 2),
            'bg-soft-info': e % 2
           })}
          >
           <Dues
            num={e + 1}
            type="quotasInitial"
            watch={watch}
            register={register}
            errors={errors}
            setValue={setValue}
            verifyFields={verifyFields}
           />
          </Col>
         ))
        ) : (
         <></>
        )}
       </Row>
      </Card.Body>
     </Card>

     <Card className="mb-3">
      <Background image={bg2} className="bg-card" />
      <Card.Body className="p-3">
       <Flex alignItems="center" wrap="wrap">
        <h6 className="fs-6 m-0 text-success">F</h6>
        <div className="flex-1">
         <h4 className="m-0 text-success">inanciamiento</h4>
         <p className="fs--2 m-0">El monto minimo en cada cuota es {currency(watch('defaultValues.minFeeFnc'))}</p>
        </div>
       </Flex>
       <Row className="g-2">
        {watch('financings') ? (
         Array.from(Array(watch('financings') * 1).keys()).map(e => (
          <Col
           sm={6}
           lg={4}
           key={e}
           className={classNames('border-end border-end-400 mb-1 py-1', {
            'bg-soft-success': !(e % 2),
            'bg-soft-info': e % 2
           })}
          >
           <Dues
            num={e + 1}
            type="quotasFinan"
            watch={watch}
            register={register}
            errors={errors}
            setValue={setValue}
            verifyFields={verifyFields}
           />
          </Col>
         ))
        ) : (
         <></>
        )}
       </Row>
      </Card.Body>
     </Card>

     <Card className="bg-transparent border fs--1">
      <Card.Body>
       <IconButton
        size="sm"
        variant="falcon-primary"
        className="float-end ms-3"
        type="submit"
        icon="tags"
        iconAlign="right"
        transform="down-1 shrink-4"
       >
        Guardar
       </IconButton>

       <IconButton
        size="sm"
        variant="falcon-danger"
        className="float-end"
        type="reset"
        icon="ban"
        iconAlign="right"
        transform="down-1 shrink-4"
        //onClick={() => reset({})}
       >
        Cancelar
       </IconButton>
      </Card.Body>
     </Card>
    </>
   ) : (
    <Spinner className="position-absolute top-50 start-50 translate-middle" animation="grow" />
   )}
  </Form>
 );
};

Notification.propTypes = { notification: PropTypes.object.isRequired, isLast: PropTypes.bool.isRequired };

export default NewOrder;
